/**
 * @param {(input: RequestInfo|URL, init?: RequestInit) => Promise<Response>} fetchImpl
 */
export function createPortalLocationApi(fetchImpl) {
    return {
        async searchCities(regionCode, query, signal) {
            const response = await fetchImpl(
                `/xhr/city-suggestions?r=${regionCode}&q=${encodeURIComponent(query)}`,
                {
                    method: 'GET',
                    signal,
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                },
            );

            if (!response.ok) {
                throw new Error(`Не удалось загрузить подсказки города: ${response.status}`);
            }

            const data = await response.json();

            return Array.isArray(data) ? data : [];
        },
    };
}

export const portalLocationApi = createPortalLocationApi((...args) => globalThis.fetch(...args));
